
import React from 'react'; 
import './index.css';
import '../../components/ProcessCard/index.css';
import '../../components/ready-started/index.css';
import '../../components/Insight/index.css';

import Programs from '../../components/programs/Programs';
import Reasons from '../../components/reasons/Reasons';
import Plans from '../../components/plans/Plans';
import Testimonials from '../../components/testimonials/Testimonials';

import Footer from '../../components/footer/Footer';
import HeroSection from '../../components/hero-section/HeroSection';

import BookTrialClass from '../../components/Classes';

const Home = () => {
 
  
    return (
        <>
       
                <HeroSection/>
                <Programs/>
                <Reasons/>
                <Plans/>
               
                <Testimonials/>
                <div className='containers mt-4 mb-5'>
                <BookTrialClass/>
                </div>
               
               
              
                <Footer/>
        </>
    );
};

export default Home;
